import type { InputDescription } from "@smartsuite/automation-engine-api";

export const requiresObject = (description: InputDescription): boolean =>
  description.editor?.editor.oneofKind === "json" &&
  !!description.editor.editor.json.requireObject;
